import React from 'react';
export function PlaySmallIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.933 5.35a1.909 1.909 0 00-1.92-.165c-.304.145-.56.369-.74.645A1.691 1.691 0 007 6.75v10.5c0 .325.095.644.274.92.179.276.435.5.74.645a1.908 1.908 0 001.92-.165l7.333-5.25c.227-.163.412-.374.54-.617a1.686 1.686 0 000-1.566 1.772 1.772 0 00-.54-.617L9.933 5.35z"
  }));
}